var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/Slider/Slider.jinja"] = require( "front/components/Slider/Slider.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectGallery.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/Slider/Slider.jinja", false, "ProjectGallery.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("Slider", t_1);
var macro_t_4 = runtime.makeMacro(
["gallery"], 
[], 
function (l_gallery, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("gallery", l_gallery);
var t_5 = "";t_5 += "<div class=\"Project-slider\">\n        ";
t_5 += runtime.suppressValue((lineno = 5, colno = 27, runtime.callWrap(runtime.memberLookup((t_1),"Slider"), "Slider[\"Slider\"]", context, [runtime.memberLookup((l_gallery),"galleryItems"),{"modifiers": ["project"]},runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n    </div>\n    ";
t_5 += runtime.suppressValue((lineno = 7, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_5 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
context.addExport("ProjectGallery");
context.setVariable("ProjectGallery", macro_t_4);
output += "\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectGallery.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Project/ProjectGallery.jinja
// module id = 69
// module chunks = 0